import type { RecordType } from "@/api/types";

/** Document type of a bibliographic record, singular ("Livre audio"). */
export const RECORD_TYPE_LABELS: Record<RecordType, string> = {
  book: "Livre",
  periodical: "Périodique",
  article: "Article",
  dvd: "DVD",
  cd: "CD",
  ebook: "Livre numérique",
  audiobook: "Livre audio",
  map: "Carte",
  score: "Partition",
  thesis: "Thèse",
  other: "Autre",
};

/** Plural form, for rules that apply to a whole type ("Livres audio"). */
export const RECORD_TYPE_PLURAL_LABELS: Record<RecordType, string> = {
  book: "Livres",
  periodical: "Périodiques",
  article: "Articles",
  dvd: "DVD",
  cd: "CD",
  ebook: "Livres numériques",
  audiobook: "Livres audio",
  map: "Cartes",
  score: "Partitions",
  thesis: "Thèses",
  other: "Autres documents",
};

export const RECORD_TYPE_ICONS: Record<RecordType, string> = {
  book: "📚",
  periodical: "📰",
  article: "📄",
  dvd: "💿",
  cd: "💿",
  ebook: "📱",
  audiobook: "🎧",
  map: "🗺️",
  score: "🎼",
  thesis: "🎓",
  other: "📦",
};

export const RECORD_TYPES = Object.keys(RECORD_TYPE_LABELS) as RecordType[];

function isRecordType(type: string): type is RecordType {
  return type in RECORD_TYPE_LABELS;
}

/** Label for a type read from untyped data (portal facets), the raw value when unknown. */
export function recordTypeLabel(type: string): string {
  return isRecordType(type) ? RECORD_TYPE_LABELS[type] : type;
}

/** Icon for a type read from untyped data, a generic box when unknown. */
export function recordTypeIcon(type: string): string {
  return isRecordType(type) ? RECORD_TYPE_ICONS[type] : RECORD_TYPE_ICONS.other;
}
